import React from "react";
import { Navbar3 } from "./components/Navbar3";
import { Layout474 } from "./components/Layout474";
import { Layout239 } from "./components/Layout239";
import { Header15 } from "./components/Header15";
import { Layout1 } from "./components/Layout1";
import { Gallery10 } from "./components/Gallery10";
import { Faq13 } from "./components/Faq13";
import { Header131 } from "./components/Header131";
import { Contact18 } from "./components/Contact18";

export default function Page() {
  return (
    <div>
      <Navbar3 />
      <Layout474 />
      <Layout239 />
      <Header15 />
      <Layout1 />
      <Gallery10 />
      <Faq13 />
      <Header131 />
      <Contact18 />
    </div>
  );
}
